export default __webpack_public_path__ + "static/media/MapWMarkers.8f1ed337.png";